<script>
import Service from '../../services/equipment-operation';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue' 
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

import DataTable from 'primevue/datatable';


export default {
  components: {
    GenericCustomMasterDataAutocompleteV2,
    ResponsiveButton
  },
  data() {
    return {
      tanks: [],
      plant: null,
      filters: {
        operationDate: new Date(),
        cvtTanks: []
      },
      loading: false,
      data: []
    }
  },
  computed: {
    constants() {
      return CommonConstants;
    },
    utils() {
      return Utils;
    },
    uiPermissions() {
      return this.$store.getters['security/uiPermissions'];
    }
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'cvtDeviation.page_title');
    this.loadTanks();
  },
  methods: {
    loadTanks(){

      let body = {
        date: this.filters.operationDate,
        idPlant: this.plant
      }
      this.tanks = [];
      this.filters.cvtTanks = [];
      Service.getCVTReportTanks(body, response => {
        if(response.success){
          this.tanks = response.data;
          this.filters.cvtTanks = [...this.tanks]
        }
        
      })
    },
    loadData() {
      let body = {
        cvtTanks: this.filters.cvtTanks,
        operationDate: this.filters.operationDate
      };

      this.data = [];
      this.loading = true;
      Service.getCVTReportLoad(body, response => {
        this.loading = false;
        if(response.success){
          this.data = response.data;
        }
      })
    },
    dowloadReportExcel(){
        this.$store.dispatch("generic/setLoading", true);
        Service.getCVTReportExcel(this.data, resp => {
          if(resp.success){
            Service.getCVTReportExcelDownload(resp.data, response => {
            
              this.$store.dispatch("generic/setLoading", false);
              if(response.success){
                  var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                  var fileLink = document.createElement('a');
              
                  fileLink.href = fileURL;
                  let fileName = "CVTReport.xlsx";
                  fileLink.setAttribute('download',fileName);
                  document.body.appendChild(fileLink);
              
                  fileLink.click();
              }else{
                  this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            })
          }else{
                this.$toast.add({detail: resp.message && resp.message != '' ? resp.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
            }
        })
        
    },
    rowClass(data){
      let classes = "";
      if(data.isBuffer){
        classes +='is-buffer'
      }  

      if(data.isMix){
        classes += 'is-mix'
      }

      console.log(classes)
      return classes;
    },
    
  },
  watch: {
    'filters.operationDate'(val){
      this.loadTanks();
    },
    'plant'(val){
      this.loadTanks();
    }
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-12 lg:col-2 md:col-6">
          <label for="plant">{{$t('registryPlant.fk')}}</label>
          <GenericCustomMasterDataAutocompleteV2
              field="label"
              v-model="plant"
              api="masterdata/registry-plant-combo"
              :addEmpty="true"
              :emptyValue="null"
                  :name="'registry-plant'"
              :emptyLabel="$t('all')"
              :format="{ label: 'description', value: 'id' }"
              :class="{'p-inputtext-sm w-full': true}" />
        </div>
        <div class="col-12 lg:col-2 md:col-6">
          <label for="tanks">{{ $t('cvtReport.tanks') }}</label>
          <MultiSelect v-model="filters.cvtTanks" :options="tanks" :placeholder="$t('cvtReport.tanks')" class="w-full">
            <template #empty>
              {{ $t('cvtReport.noTanksForFilters') }}
            </template>
          </MultiSelect>
        </div>
        <div class="col-12 lg:col-2 md:col-6">
          <label for="dateTo">{{ $t('cvtReport.operationDate') }}</label>
          <Calendar 
            v-model="filters.operationDate"
            :dateFormat="constants.DATE_FORMAT_POINT"
            :showTime="true" :hideOnDateTimeSelect="true"
            :showIcon="true" :showButtonBar="true" :yearNavigator="true"
            class="w-full p-inputtext-sm " />
        </div>
        <div class="col-12 lg:col-4 mt-4">
          <ResponsiveButton :label="$t('btn.load')" icon="pi pi-upload" class="p-button-info mr-2" @click="loadData" />
          <ResponsiveButton :label="$t('btn.download')" icon="pi pi-file-excel" class="mx-1" @click="dowloadReportExcel"/>   

        </div>
        <div class="col-12">
            <DataTable :value="data" :reorderableColumns="true" :loading="loading"
            :rowClass="rowClass">
              <Column field="fiscalNotificationCode" :header="$t('cvtReport.fiscalNotificationCode')" />
              <Column field="operationDate" :header="$t('cvtReport.operationDate')">
                <template #body="element" >
                  {{element.data.operationDate != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(element.data.operationDate)) : null}}
                </template>
              </Column>
              <Column field="tankCode" :header="$t('cvtReport.tankCode')" />
              <Column field="initialStock" :header="$t('cvtReport.initialStock')" />
              <Column field="finalStock" :header="$t('cvtReport.finalStock')" />
              <Column field="extractProduct" :header="$t('cvtReport.extractProduct')"/>
              <Column field="realStock" :header="$t('cvtReport.realStock')"/>
              <Column field="realExtractProduct" :header="$t('cvtReport.realExtractProduct')"/>
              <Column field="stockDifference" :header="$t('cvtReport.stockDifference')"/>
              <Column field="deviationPerc" :header="$t('cvtReport.deviationPerc')"/>
              <template #empty>
                {{ $t('noRecordsFound') }}
              </template>
            </DataTable>
        </div>
      </div>
    </div>
  </main>
</template>

<style>

  .tank-box{
    border: 1px solid #dee2e6;
    border-width: 0 0 2px 0;
  }

  .is-buffer{
    background-color: yellow !important;
  }

  .is-mix{
    background-color: orange !important;
  }
</style>